// @ts-nocheck
(function () {
  console.log("🟢 Vertex AI Search (Dark Premium Sidebar)");

  // Pulls the freshest live image for a product straight from the CURRENT Shopify store.
  // Robust for migrated stores where the search API's image URLs/handles are stale or empty:
  // tries the handle, its owfam- prefixed/stripped variants, then a cleaned title search.
  window.vrRecoverShopifyImage = async function (img, handle = '', title = '') {
    try {
      let freshUrl = '';
      let realUrl = ''; // the real, working /products/... URL for this item on THIS store
      const handleCandidates = [];

      // Most reliable source: the handle in the card's own PDP link (this is the
      // handle that makes the card clickable, so it definitely exists on this store).
      try {
        let link = img.closest('a[href*="/products/"]');
        if (!link) {
          const wrap = img.closest('.card-wrapper') || img.closest('.vertex-grid-item');
          if (wrap) link = wrap.querySelector('a[href*="/products/"]');
        }
        if (link) {
          const href = link.getAttribute('href') || '';
          const h = (href.split('/products/')[1] || '').split('?')[0].split('#')[0];
          if (h) handleCandidates.push(h);
        }
      } catch (le) { /* ignore */ }

      // Then the API-provided handle and its owfam- variants.
      if (handle) {
        handleCandidates.push(handle);
        if (handle.indexOf('owfam-') === 0) handleCandidates.push(handle.slice(6));
        else handleCandidates.push('owfam-' + handle);
      }

      const seen = {};
      for (let i = 0; i < handleCandidates.length && !freshUrl; i++) {
        const h = handleCandidates[i];
        if (!h || seen[h]) continue;
        seen[h] = true;
        try {
          const res = await fetch(`/products/${h}.js`);
          if (res.ok) {
            const product = await res.json();
            if (product.images && product.images.length > 0) {
              freshUrl = product.images[0];
              realUrl = '/products/' + (product.handle || h);
            }
          }
        } catch (he) { /* try next candidate */ }
      }

      // Last resort: predictive search by a cleaned title.
      if (!freshUrl && title) {
        const cleanTitle = title.split('•')[0].split('|')[0].trim() || title;
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(cleanTitle)}&resources[type]=product`);
        if (res.ok) {
          const data = await res.json();
          const products = data.resources && data.resources.results && data.resources.results.products;
          if (products && products.length > 0) {
            freshUrl = products[0].image || products[0].featured_image;
            realUrl = products[0].url || realUrl;
          }
        }
      }

      if (freshUrl) {
        if (freshUrl.indexOf('//') === 0) freshUrl = 'https:' + freshUrl;
        console.log(`Vertex Search: ✅ Recovered live Shopify image for "${handle || title}": ${freshUrl}`);
        img.onerror = null; // trust this URL; avoid recovery loops
        img.style.opacity = '1';
        img.src = freshUrl;
        const rugCard = img.closest('.rug-card') || img.closest('.card') || img.closest('.card-wrapper');
        if (rugCard) {
          const btn = rugCard.querySelector('.see-in-room-btn');
          if (btn) btn.setAttribute('data-rug', freshUrl);
        }
        // Repoint the card's product links to the REAL url so clicking never 404s.
        const gridCard = img.closest('.vertex-grid-item');
        if (gridCard && realUrl) {
          gridCard.querySelectorAll('a.full-unstyled-link').forEach((a) => a.setAttribute('href', realUrl));
        }
        return true;
      }
      console.warn(`Vertex Search: ⚠️ Could not recover image for "${handle || title}" — product not found on this store, hiding card. (tried handles: [${handleCandidates.join(', ')}])`);
    } catch (e) {
      console.error("Vertex Search: Shopify image recovery error:", e);
    }
    // No image AND no matching product on this store — this item would 404 on click
    // (stale catalog entry not present on vogue-rugs-2), so remove the whole card so
    // customers never see an empty/broken result. This is a front-end safety net only;
    // the real fix is re-indexing the search catalog against the current store.
    const deadCard = img.closest('.vertex-grid-item');
    if (deadCard) {
      deadCard.style.display = 'none';
    } else {
      img.style.opacity = '0.3';
    }
    img.onerror = null;
    return false;
  };

  window.handleVertexImageError = function (img, imagesBase64, handle = '', title = '') {
    // On the migrated store the search API often returns DEAD external image URLs
    // (e.g. www.owimages.com, which doesn't resolve), and all of a product's alternate
    // URLs share that same dead host — so retrying them or proxying them is pointless and
    // caused an infinite loop. Go straight to the live Shopify product image instead.
    if (img.getAttribute('data-retried-discovery')) {
      img.style.opacity = '0.3';
      img.onerror = null;
      return;
    }
    img.setAttribute('data-retried-discovery', 'true');
    window.vrRecoverShopifyImage(img, handle, title);
  };

  const initSearch = () => {
    const sort = document.getElementById("SortBy");
    if (sort) sort.onchange = null;

    let currentPage = 1;
    // Per-page size is user-selectable (?page_size=) and clamped to an allowed set.
    const PAGE_SIZE_OPTIONS = [24, 48, 72, 96];
    function getPageSize() {
      const raw = parseInt(new URLSearchParams(window.location.search).get('page_size'), 10);
      return PAGE_SIZE_OPTIONS.indexOf(raw) !== -1 ? raw : 24;
    }
    let ITEMS_PER_PAGE = getPageSize();
    let totalItems = 0;
    let currentFacets = [];
    // Remembers every facet value we've seen so options don't vanish once a filter is
    // applied (the API returns counts AFTER filtering, which zeroes out the others).
    // Lets shoppers switch between options without deselecting first.
    const facetMemory = {};

    const performAiSearch = async (page = 1) => {
      ITEMS_PER_PAGE = getPageSize(); // keep in sync with ?page_size= (direct loads / back-forward)
      let vertexRoot = document.getElementById("vertex-search-root");
      const shopifyGrid = document.getElementById("product-grid");

      if (!vertexRoot) {
        const templateSearch = document.querySelector(".template-search");
        if (!templateSearch) return;
        vertexRoot = document.createElement("div");
        vertexRoot.id = "vertex-search-root";
        vertexRoot.style.display = "none";
        templateSearch.appendChild(vertexRoot);
      }

      const params = new URLSearchParams(window.location.search);
      let hasBaseQuery = false;
      let baseParams = new URLSearchParams();
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        hasBaseQuery = true;
        baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
        for (const [key, value] of baseParams.entries()) {
          if (!params.has(key)) {
            params.append(key, value);
          }
        }
      }

      const query = params.get("q")?.trim() || "";
      const hasFilters = ['shape', 'color', 'size_bucket', 'size', 'style', 'material', 'pattern', 'vendor', 'brand', 'brands', 'collection', 'construction', 'pile_height', 'price'].some(k => params.has(k));
      if (!query && !hasFilters && !hasBaseQuery) return;

      if (page === 1) {
        if (shopifyGrid) shopifyGrid.style.display = "none";
        vertexRoot.style.display = "block";
        const searchTarget = query ? `"<strong>${query}</strong>"` : "filtered rugs";

        if (!vertexRoot.querySelector('.vertex-skeleton')) {
          vertexRoot.innerHTML = `<p style="text-align:center;padding:40px;color:#fff;">Searching for ${searchTarget}…</p>`;
        }

        document.querySelectorAll(".template-search__results, .template-search__header p")
          .forEach(el => {
            if (el.textContent.includes("No results") || el.textContent.includes("results found for") || el.textContent.includes("Search results")) {
              el.style.display = "none";
            }
          });
      }

      try {
        const baseUrl = window.BACKEND_BASE_URL || window.location.origin;
        const isEmptySearch = window.location.pathname === '/search' && (!params.has('q') || params.get('q').trim() === '');
        const isBrowseMode = (window.vertexPageContext && window.vertexPageContext.mode === 'browse') || isEmptySearch;
        let apiPath = isBrowseMode ? '/api/browse' : '/api/search';

        let fetchUrl = new URL(`${baseUrl}${apiPath}`);
        let fetchParams = new URLSearchParams(params.toString());
        
        // Clean up empty 'q' parameter for browse requests to avoid sending q=+
        if (apiPath === '/api/browse' && fetchParams.has('q') && fetchParams.get('q').trim() === '') {
          fetchParams.delete('q');
        }

        fetchUrl.search = fetchParams.toString();
        fetchUrl.searchParams.set("page", page);
        fetchUrl.searchParams.set("page_size", ITEMS_PER_PAGE);
        if (window['shopkeeperTenant']) {
          fetchUrl.searchParams.set("tenant", window['shopkeeperTenant']);
        }

        let res = await fetch(fetchUrl.toString());
        if (!res.ok) throw new Error(`API error: ${res.status}`);

        let data = await res.json();

        const results = data.results || data.products || [];
        totalItems = data.totalSize || data.total_size || results.length;
        currentFacets = data.facets || [];
        // Merge into facet memory so previously-seen values stay selectable even when the
        // current (filtered) response only returns the chosen value. Keep the highest count seen.
        currentFacets.forEach((f) => {
          if (!f || !f.key) return;
          if (!facetMemory[f.key]) facetMemory[f.key] = {};
          (f.values || []).forEach((v) => {
            const prev = facetMemory[f.key][v.value] || 0;
            facetMemory[f.key][v.value] = Math.max(prev, v.count || 0);
          });
        });
        currentPage = page;

        // ==========================================
        // Vertex Public Interception Event
        // Allows external UI rendering override
        // ==========================================
        const eventDetail = {
          results,
          data,
          page,
          query,
          totalItems,
          currentFacets,
          currentPage,
          params: Object.fromEntries(params.entries()),
          isBrowseMode,
          apiPath
        };

        // New canonical event
        const searchResultsEvent = new CustomEvent('vertex:search:results', {
          detail: eventDetail,
          cancelable: true
        });

        document.dispatchEvent(searchResultsEvent);

        // Backwards compatibility event
        const legacyEvent = new CustomEvent('vertex:api:data', {
          detail: eventDetail,
          cancelable: true
        });

        document.dispatchEvent(legacyEvent);

        // External UI took ownership
        if (
          searchResultsEvent.defaultPrevented ||
          legacyEvent.defaultPrevented
        ) {
          console.log('Vertex Search: External renderer tried to intercept, but we are enforcing the new UI.');
          // return; // COMMENTED OUT TO ENFORCE OUR NEW UI
        }

        if (results.length === 0 && page === 1) {
          vertexRoot.innerHTML = `
            <div class="vertex-no-results" style="text-align:center; padding:100px 20px; color:#aaa;">
              <h2 style="color:#fff; text-transform:uppercase; letter-spacing:0.1em; font-size:20px; margin-bottom:15px;">No results found</h2>
              <p style="font-size:14px;">We couldn't find any rugs matching "<strong>${query}</strong>".</p>
              <p style="margin-top:20px;">
                <button onclick="window.location.href=window.location.pathname" style="background:#fff; color:#000; border:none; padding:12px 30px; font-weight:900; text-transform:uppercase; cursor:pointer; font-size:11px; letter-spacing:0.1em;">Clear Search</button>
              </p>
            </div>
          `;
          return;
        }

        renderPage(results, data);

        // Bind See In My Room buttons on rendered cards
        if (window.bindSeeInRoomButtons) {
          window.bindSeeInRoomButtons();
        }

        // ==========================================
        // Vertex Post-Render Lifecycle Event
        // Allows external scripts to augment UI (e.g. badges, quick view)
        // ==========================================
        document.dispatchEvent(
          new CustomEvent('vertex:ui:rendered', {
            detail: {
              results,
              data,
              page,
              query,
              totalItems,
              currentPage,
              params: Object.fromEntries(params.entries())
            }
          })
        );
      } catch (err) {
        console.error("Vertex search error:", err);
        if (page === 1) {
          if (shopifyGrid) shopifyGrid.style.display = "block";
          vertexRoot.style.display = "none";
        }
      }
    };

    function goToSearchAiPage(page) {
      const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE) || 1;
      const target = Math.min(Math.max(page, 1), totalPages);
      if (target === currentPage) return;
      performAiSearch(target);
      const root = document.getElementById("vertex-search-root");
      if (root) window.scrollTo({ top: root.offsetTop - 80, behavior: "smooth" });
    }
    // dir-based (Prev/Next) and absolute page jump
    window.changeSearchAiPage = function (dir) { goToSearchAiPage(currentPage + dir); };
    window.goToSearchAiPage = goToSearchAiPage;

    // User-selectable page size — writes ?page_size= and reloads results from page 1.
    window.setSearchPageSize = function (size) {
      const params = new URLSearchParams(window.location.search);
      params.set('page_size', size);
      window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
      ITEMS_PER_PAGE = getPageSize();
      performAiSearch(1);
    };

    window.toggleVertexFilter = (key, value) => {
      const vertexRoot = document.getElementById("vertex-search-root");
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        const baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
        if (baseParams.has(key)) {
          console.warn(`Vertex Search: Cannot modify locked base filter category '${key}'`);
          return;
        }
      }

      const params = new URLSearchParams(window.location.search);
      const currentValues = params.getAll(key);
      if (currentValues.includes(value)) {
        const newValues = currentValues.filter(v => v !== value);
        params.delete(key);
        newValues.forEach(v => params.append(key, v));
      } else {
        params.append(key, value);
      }
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.pushState({}, '', newUrl);
      performAiSearch(1);
    };

    window.toggleMobileFilters = () => {
      const sidebar = document.querySelector('.vertex-sidebar');
      if (sidebar) {
        sidebar.classList.toggle('active');
        document.body.style.overflow = sidebar.classList.contains('active') ? 'hidden' : '';
      }
    };

    // ── Filter clean-up (per client review) ─────────────────────────────────
    // The catalog returns messy/duplicated Construction values and too many Style
    // values. We collapse them into clean, customer-friendly buckets in the UI.
    // Each bucket still filters by ALL of its underlying raw catalog values.
    // Construction buckets (per client review):
    //   Hand Made   – Hand Knotted, Hand-Knotted, Hand-loomed, Hand Hooked, Hand Woven
    //   Hand Tufted
    //   Machine Made – Machine-Tufted, Machine-Woven, Power Loomed
    var CONSTRUCTION_ORDER = ['Hand Made', 'Hand Tufted', 'Machine Made'];
    function vrCanonConstruction(raw) {
      const s = String(raw || '').toLowerCase();
      // Machine is checked first so "Machine-Tufted" / "Machine-Woven" don't leak into the hand buckets.
      if (s.indexOf('machine') !== -1 || s.indexOf('power loom') !== -1 || s.indexOf('power-loom') !== -1 || s.indexOf('powerloom') !== -1) return 'Machine Made';
      if (s.indexOf('tuft') !== -1) return 'Hand Tufted';
      if (s.indexOf('knot') !== -1 || s.indexOf('loom') !== -1 || s.indexOf('hook') !== -1 || s.indexOf('woven') !== -1 || s.indexOf('weave') !== -1 || s.indexOf('hand') !== -1) return 'Hand Made';
      return raw;
    }
    // The clean "Design" categories, in the same order as the header DESIGN dropdown.
    var DESIGN_ORDER = ['Traditional', 'Modern', 'Transitional', 'Geometric', 'Floral', 'Abstract', 'Solid / Plain', 'Outdoor'];
    function vrCanonStyle(raw) {
      const s = String(raw || '').toLowerCase();
      if (/(traditional|oriental|persian|classic)/.test(s)) return 'Traditional';
      if (/transitional/.test(s)) return 'Transitional';
      if (/(modern|contemporary|neutral)/.test(s)) return 'Modern';
      if (/(geometric|trellis|lattice|moroccan|chevron|aztec|southwest|tribal)/.test(s)) return 'Geometric';
      if (/(floral|botanical|garden|nature)/.test(s)) return 'Floral';
      if (/abstract/.test(s)) return 'Abstract';
      if (/(solid|plain|textured|shag|heather|casual)/.test(s)) return 'Solid / Plain';
      if (/outdoor/.test(s)) return 'Outdoor';
      return null; // unknown style values are dropped to keep the list simple
    }
    // Material buckets (per client review). Order matters: most specific blends first.
    //   Wool | Silk | Wool & Silk | Synthetic (Polypropylene and/or Polyester) | Jute / Natural | Cotton | Viscose
    var MATERIAL_ORDER = ['Wool', 'Silk', 'Wool & Silk', 'Synthetic (Polypropylene and/or Polyester)', 'Jute / Natural', 'Cotton', 'Viscose'];
    function vrCanonMaterial(raw) {
      const s = String(raw || '').toLowerCase();
      if (/wool\s*(&|and|\/)\s*silk/.test(s)) return 'Wool & Silk';
      if (/viscose\s*(&|and|\/)\s*silk/.test(s)) return ['Viscose', 'Silk'];
      if (/(polypropylene|polyester|synthetic|nylon|olefin|acrylic)/.test(s)) return 'Synthetic (Polypropylene and/or Polyester)';
      if (/(jute|sisal|hemp|seagrass|natural)/.test(s)) return 'Jute / Natural';
      if (/cotton/.test(s)) return 'Cotton';
      if (/(viscose|rayon|bamboo silk|art silk|artificial silk)/.test(s)) return 'Viscose';
      if (/silk/.test(s)) return 'Silk';
      if (/wool/.test(s)) return 'Wool';
      return null; // drop unknown/blank material values to keep the list clean
    }
    // Returns [{ label, count, values:[raw,...] }]. A canon fn may return a string,
    // null (drop), or an array of labels (one raw value feeds several buckets).
    function vrGroupFacetValues(key, values) {
      const k = key.replace('attributes.', '');
      let canon = null;
      if (k === 'construction') canon = vrCanonConstruction;
      else if (k === 'style' || k === 'styles' || k === 'design' || k === 'designs') canon = vrCanonStyle;
      else if (k === 'material' || k === 'materials') canon = vrCanonMaterial;
      if (!canon) return values.map(fv => ({ label: fv.value, count: fv.count, values: [fv.value] }));
      const map = {}, order = [];
      values.forEach(fv => {
        let labels = canon(fv.value);
        if (labels == null) return;
        if (!Array.isArray(labels)) labels = [labels];
        labels.forEach(label => {
          if (!map[label]) { map[label] = { label: label, count: 0, values: [] }; order.push(label); }
          map[label].count += (fv.count || 0);
          if (map[label].values.indexOf(fv.value) === -1) map[label].values.push(fv.value);
        });
      });
      let result = order.map(l => map[l]);
      // Order the collapsed buckets in a fixed, customer-friendly order.
      var fixedOrder = null;
      if (canon === vrCanonStyle) fixedOrder = DESIGN_ORDER;
      else if (canon === vrCanonMaterial) fixedOrder = MATERIAL_ORDER;
      else if (canon === vrCanonConstruction) fixedOrder = CONSTRUCTION_ORDER;
      if (fixedOrder) {
        result.sort(function (a, b) {
          var ia = fixedOrder.indexOf(a.label); var ib = fixedOrder.indexOf(b.label);
          return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
        });
      }
      return result;
    }

    // Toggle a whole bucket: adds all underlying values if none selected, else removes them all.
    window.toggleVertexFilterMulti = (key, valuesB64) => {
      const vertexRoot = document.getElementById("vertex-search-root");
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        const baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
        if (baseParams.has(key)) {
          console.warn(`Vertex Search: Cannot modify locked base filter category '${key}'`);
          return;
        }
      }
      let vals = [];
      try { vals = JSON.parse(decodeURIComponent(escape(atob(valuesB64)))); } catch (e) { try { vals = JSON.parse(atob(valuesB64)); } catch (e2) { vals = []; } }
      if (!vals.length) return;
      const params = new URLSearchParams(window.location.search);
      const current = params.getAll(key);
      const anySelected = vals.some(v => current.includes(v));
      let remaining;
      if (anySelected) {
        remaining = current.filter(v => vals.indexOf(v) === -1);
      } else {
        remaining = current.slice();
        vals.forEach(v => { if (remaining.indexOf(v) === -1) remaining.push(v); });
      }
      params.delete(key);
      remaining.forEach(v => params.append(key, v));
      window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
      performAiSearch(1);
    };

    function renderFilters(facets, isMobile = false) {
      if (!facets || facets.length === 0) return "";
      const params = new URLSearchParams(window.location.search);

      const vertexRoot = document.getElementById("vertex-search-root");
      let baseParams = new URLSearchParams();
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
      }

      // Render these facets, in this display order (priority filters per the build spec:
      // Size, Shape, Color, Style, Material, Vendor/Brand, Collection, Pattern, Construction,
      // Pile Height, Price). Vendor/brand can come back under a few key names, so cover them.
      const allowedKeys = [
        'size_bucket', 'size', 'shape', 'color', 'colors', 'design', 'designs', 'style', 'styles',
        'material', 'materials', 'vendor', 'brand', 'brands', 'collection', 'collections',
        'pattern', 'construction', 'pile_height'
      ];
      const labels = {
        size_bucket: 'Size', size: 'Size', shape: 'Shape', color: 'Color', colors: 'Color',
        design: 'Design', designs: 'Design', style: 'Design', styles: 'Design',
        material: 'Material', materials: 'Material',
        vendor: 'Brand', brand: 'Brand', brands: 'Brand',
        collection: 'Collection', collections: 'Collection',
        pattern: 'Pattern', construction: 'Construction', pile_height: 'Pile Height',
        price: 'Price', price_bucket: 'Price'
      };
      const filteredFacets = facets
        .filter(f => allowedKeys.includes(f.key.replace("attributes.", "")))
        .sort((a, b) => allowedKeys.indexOf(a.key.replace("attributes.", "")) - allowedKeys.indexOf(b.key.replace("attributes.", "")));

      const shapeIcons = {
        rectangle: '<svg viewBox="0 0 24 24"><rect x="2" y="6" width="20" height="12" rx="1"/></svg>',
        round: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/></svg>',
        oval: '<svg viewBox="0 0 24 24"><ellipse cx="12" cy="12" rx="7" ry="9.5"/></svg>',
        square: '<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="1"/></svg>',
        runner: '<svg viewBox="0 0 24 24"><rect x="8.5" y="2" width="7" height="20" rx="1"/></svg>'
      };
      const caretSvg = '<svg class="vfacet-caret" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

      return `
        <div class="vfacets">
          <div class="vfacets__head">
            <h3 class="vfacets__title">Filters</h3>
            <a href="#" class="vfacets__clear" onclick="const q=new URLSearchParams(window.location.search).get('q'); window.location.href = q ? (window.location.pathname+'?q='+encodeURIComponent(q)) : window.location.pathname; return false;">Clear all</a>
            <button class="vertex-mobile-close vfacets__close" onclick="toggleMobileFilters()" aria-label="Close filters">&times;</button>
          </div>
          ${filteredFacets.map((facet, idx) => {
        const key = facet.key.replace("attributes.", "");
        const label = labels[key] || (key.charAt(0).toUpperCase() + key.slice(1).replace("_", " "));
        if (!facet.values || facet.values.length === 0) return "";
        // Build the option list from the union of remembered values for this facet, so an
        // applied filter doesn't hide the other options (the API zeroes them out once filtered).
        const mem = facetMemory[facet.key] || {};
        const curMap = {};
        facet.values.forEach(fv => { curMap[fv.value] = fv.count; });
        const unionVals = Object.keys(mem).length ? Object.keys(mem) : facet.values.map(fv => fv.value);
        let availableValues = unionVals.map(value => ({
          value: value,
          count: (curMap[value] != null ? curMap[value] : (mem[value] || 0))
        }));
        // Keep anything that is currently available OR was ever available (so it stays clickable).
        availableValues = availableValues.filter(fv => fv.count > 0 || mem[fv.value] > 0);
        if (availableValues.length === 0) return "";
        const isShape = key === 'shape';
        const openAttr = idx < 3 ? 'open' : '';
        return `
              <details class="vfacet" ${openAttr}>
                <summary class="vfacet__summary"><span>${label}</span>${caretSvg}</summary>
                <ul class="vfacet__list">
                  ${vrGroupFacetValues(key, availableValues).slice(0, 40).map(g => {
          const isSelectedBase = g.values.some(v => baseParams.getAll(key).includes(v));
          const isSelected = g.values.some(v => params.getAll(key).includes(v)) || isSelectedBase;
          const isLocked = baseParams.has(key);
          const icon = isShape ? (shapeIcons[(g.label || '').toString().toLowerCase()] || '') : '';
          let valsB64 = '';
          try { valsB64 = btoa(unescape(encodeURIComponent(JSON.stringify(g.values)))); } catch (e) { valsB64 = btoa(JSON.stringify(g.values)); }
          return `
                      <li class="vfacet__item">
                        <label class="vfacet__label${isSelected ? ' is-selected' : ''}${isLocked && !isSelectedBase ? ' is-disabled' : ''}">
                          <input type="checkbox" ${isSelected ? 'checked' : ''} ${isLocked ? 'disabled' : ''} onclick="${isLocked ? 'event.preventDefault();' : `toggleVertexFilterMulti('${key}', '${valsB64}')`}">
                          ${icon ? `<span class="vfacet__icon">${icon}</span>` : ''}
                          <span class="vfacet__name">${g.label}</span>
                          <span class="vfacet__count">(${g.count})</span>
                          ${isSelectedBase ? '<span class="vfacet__lock" title="Required for this page">🔒</span>' : ''}
                        </label>
                      </li>`;
        }).join("")}
                </ul>
              </details>`;
      }).join("")}
        </div>
      `;
    }

    window.vertexNavigate = async function (e, url, handle, title) {
      e.preventDefault();

      // 1. Try original URL
      try {
        const res = await fetch(url, { method: 'HEAD' });
        if (res.ok) { window.location.href = url; return; }
      } catch (err) { }

      // 2. Try with owfam- prefix
      if (handle && !handle.startsWith('owfam-')) {
        const fallbackUrl = '/products/owfam-' + handle;
        try {
          const res2 = await fetch(fallbackUrl, { method: 'HEAD' });
          if (res2.ok) { window.location.href = fallbackUrl; return; }
        } catch (err) { }
      }
      // 3. Try removing owfam- prefix
      else if (handle && handle.startsWith('owfam-')) {
        const fallbackUrl = '/products/' + handle.substring(6);
        try {
          const res3 = await fetch(fallbackUrl, { method: 'HEAD' });
          if (res3.ok) { window.location.href = fallbackUrl; return; }
        } catch (err) { }
      }

      // 4. SMART RECOVERY: Query Shopify's predictive search to find the REAL handle!
      try {
        // Use the title or replace dashes in handle with spaces to search
        const searchQuery = encodeURIComponent(title || handle.replace(/-/g, ' '));
        const suggestRes = await fetch(`/search/suggest.json?q=${searchQuery}&resources[type]=product`);
        if (suggestRes.ok) {
          const suggestData = await suggestRes.json();
          if (suggestData.resources && suggestData.resources.results && suggestData.resources.results.products.length > 0) {
            // Found the real product in Shopify! Navigate to it.
            window.location.href = suggestData.resources.results.products[0].url;
            return;
          }
        }
      } catch (err) {
        console.error("Vertex Smart Recovery failed:", err);
      }

      // 5. Ultimate fallback
      window.location.href = url;
    };

    function renderPage(items, apiData) {
      try {
        document.body.style.overflow = ''; // Reset scroll lock in case mobile filters were open
        const params = new URLSearchParams(window.location.search);
        const query = params.get("q")?.trim() || "";

        let fallbackBannerHtml = "";
        if (apiData && apiData.fallback_stage > 0) {
          const qLower = (query || "").toLowerCase();
          const colorsList = ['yellow', 'blue', 'red', 'green', 'grey', 'gray', 'black', 'white', 'beige', 'pink', 'orange', 'brown', 'purple', 'navy', 'ivory', 'cream', 'teal', 'gold', 'silver', 'charcoal', 'neutral', 'multi'];
          const shapesList = ['round', 'runner', 'oval', 'square', 'rectangle'];
          const stylesList = ['traditional', 'modern', 'vintage', 'boho', 'shag', 'geometric', 'abstract', 'distressed', 'classic', 'transitional'];

          const foundColors = colorsList.filter(c => qLower.includes(c));
          const foundShapes = shapesList.filter(s => qLower.includes(s));
          const foundStyles = stylesList.filter(st => qLower.includes(st));

          let suggestionPills = "";
          const suggestedPillsList = [];

          foundColors.forEach(c => {
            const pillQuery = `${c} rugs`;
            if (pillQuery.toLowerCase() !== qLower) {
              suggestedPillsList.push({ label: `${c} rugs`, query: pillQuery });
            }
          });
          foundShapes.forEach(s => {
            const pillQuery = `${s} rugs`;
            if (pillQuery.toLowerCase() !== qLower) {
              suggestedPillsList.push({ label: `${s} rugs`, query: pillQuery });
            }
          });
          foundStyles.forEach(st => {
            const pillQuery = `${st} rugs`;
            if (pillQuery.toLowerCase() !== qLower) {
              suggestedPillsList.push({ label: `${st} rugs`, query: pillQuery });
            }
          });

          if (suggestedPillsList.length > 0) {
            suggestionPills = `
            <div style="margin-top: 16px; display: flex; gap: 8px; flex-wrap: wrap; align-items: center; border-top: 1px solid rgba(0, 0, 0, 0.1); padding-top: 14px;">
              <span style="font-size: 11px; font-weight: 700; color: #777; text-transform: uppercase; letter-spacing:0.08em; margin-right: 4px;">Explore separately:</span>
              ${suggestedPillsList.map(pill => `
                <a href="/search?q=${encodeURIComponent(pill.query)}" 
                   style="display:inline-flex; align-items:center; padding: 6px 14px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #e0e0e0; font-size: 11px; font-weight: 700; border-radius: 20px; text-decoration: none; text-transform: capitalize; transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);" 
                   onmouseover="this.style.background='#f7f7f7'; this.style.color='#000'; this.style.borderColor='#fff'; this.style.transform='translateY(-1px)';" 
                   onmouseout="this.style.background='rgba(255,255,255,0.05)'; this.style.color='#e0e0e0'; this.style.borderColor='rgba(255,255,255,0.1)'; this.style.transform='none';">
                  ${pill.label}
                </a>
              `).join('')}
            </div>
          `;
          }

          // Map raw developer stage descriptions to customer-friendly copy
          let friendlyReason = "Showing our closest matching items instead.";
          switch (Number(apiData.fallback_stage)) {
            case 1:
              friendlyReason = "We don't have that exact size in stock, but here are some close matches.";
              break;
            case 2:
              friendlyReason = "We couldn't find that specific brand, so we are showing matches across all our premium makers.";
              break;
            case 3:
              friendlyReason = "That specific size is currently unavailable, showing matches in other sizes with the same color and style.";
              break;
            case 4:
              friendlyReason = "That specific shape is currently unavailable, showing matches in other shapes with the same color and style.";
              break;
            case 5:
              friendlyReason = "We couldn't find matches in that exact color or style, showing alternative choices in the requested size.";
              break;
            case 6:
            case 7:
              friendlyReason = "We couldn't find matches for this exact combination, but here are some popular styles you might love.";
              break;
            default:
              friendlyReason = apiData.fallback_reason || "Showing our closest matching items instead.";
          }

          fallbackBannerHtml = `
          <div class="vertex-fallback-banner" style="background: rgba(255, 255, 255, 0.02); border: 1px solid rgba(255, 255, 255, 0.08); padding: 20px 24px; margin-bottom: 35px; border-radius: 8px; text-align: left; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);">
            <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 16px; color: #ffa500; display: inline-flex; align-items: center; justify-content: center; line-height: 1;">💡</span>
              <h4 style="margin: 0; color: #fff; text-transform: uppercase; font-size: 12px; font-weight: 800; letter-spacing: 0.1em; line-height: 1.2;">No direct match found for "${query}"</h4>
            </div>
            <p style="margin: 0; font-size: 13px; color: #aaa; line-height: 1.6; font-weight: 400;">
              ${friendlyReason}
            </p>
            ${suggestionPills}
          </div>
        `;
        }

        const vertexRoot = document.getElementById("vertex-search-root");

        const getOptimizedImageUrl = (url, size = 600) => {
          if (!url) return "";
          let clean = url.toString().trim();
          if (clean.startsWith("//")) clean = "https:" + clean;

          // Discovery AI (GCS) images: serve the lightweight WEBP "card" variant for fast
          // grid loading. Pattern: .../<product>/<format>/<file>.webp  (format = thumb|card|full)
          // e.g. .../oriental_weavers/anr-6842d-stone/card/andorra_6842d.webp
          if (clean.indexOf("storage.googleapis.com") !== -1 || clean.indexOf("discovery-ai-v3-public") !== -1) {
            // Load the webp "/card/" variant directly. The webp keeps the SAME base filename
            // as the .jpg, e.g. .../als-8033k-red/atlas_8033k.jpg
            //                ->  .../als-8033k-red/card/atlas_8033k.webp
            try {
              const qIndex = clean.indexOf("?");
              const query = qIndex === -1 ? "" : clean.slice(qIndex);
              let parts = (qIndex === -1 ? clean : clean.slice(0, qIndex)).split("/");
              parts[parts.length - 1] = parts[parts.length - 1].replace(/\.(jpe?g|png|gif)$/i, ".webp");
              const prev = parts[parts.length - 2];
              if (prev === "thumb" || prev === "full") {
                parts[parts.length - 2] = "card";
              } else if (prev !== "card") {
                parts.splice(parts.length - 1, 0, "card");
              }
              clean = parts.join("/") + query;
            } catch (e) { /* leave url unchanged */ }
            return clean;
          }


          // Speed: pull a right-sized image from Shopify's CDN instead of the full-res
          // master, so search/browse thumbnails download far faster.
          try {
            if (clean.indexOf("cdn.shopify.com") !== -1 && clean.indexOf("width=") === -1) {
              clean += (clean.indexOf("?") === -1 ? "?" : "&") + "width=" + size;
            }
          } catch (e) { /* leave url unchanged */ }
          return clean;
        };

        if (!items || items.length === 0) {
          const currentFilters = [];
          const filterKeys = ['shape', 'color', 'size_bucket', 'style', 'material'];
          filterKeys.forEach(key => {
            const val = params.get(key);
            if (val) currentFilters.push(`<span style="color:#000;">${val}</span>`);
          });

          const sizeBucket = params.get('size_bucket');
          let suggestionHtml = "";
          if (sizeBucket) {
            const suggestions = {
              '5x8': '8x10 or 9x12',
              '8x10': '9x12 or 10x14',
              '2x3': '3x5 or 4x6',
              '3x5': '5x8 or 8x10',
              '9x12': '10x14 or 8x10'
            };
            const alt = suggestions[sizeBucket];
            if (alt) {
              suggestionHtml = `<p style="color:#000; font-weight:700; margin-top:20px; font-size:13px; text-transform:uppercase; letter-spacing:0.1em;">Try searching for <span style="text-decoration:underline; cursor:pointer;" onclick="toggleVertexFilter('size_bucket', '${alt.split(' or ')[0]}')">${alt}</span> instead?</p>`;
            }
          }

          const filterDesc = currentFilters.length > 0 ? ` with ${currentFilters.join(' + ')}` : '';

          vertexRoot.innerHTML = `
          <div class="vertex-search-layout" style="display:block; text-align:center; padding: 100px 20px; color:#fff;">
            <div style="font-size: 64px; margin-bottom: 20px;">🔍</div>
            <h2 style="font-size: 24px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 15px;">We couldn't find any rugs${filterDesc}</h2>
            <p style="color: #aaa; font-size: 14px; max-width: 500px; margin: 0 auto 30px; line-height: 1.6;">
              Our weavers are talented, but this specific combination is elusive! <br>
              Try clearing some filters or exploring a different size to find your perfect match.
            </p>
            ${suggestionHtml}
            <div style="margin-top:40px;">
              <button onclick="const cq = new URLSearchParams(window.location.search).get('q'); window.location.href = cq ? (window.location.pathname + '?q=' + encodeURIComponent(cq)) : window.location.pathname;" 
                style="padding: 15px 40px; background: #fff; color: #000; border: 1px solid #ddd; font-weight: 900; text-transform: uppercase; letter-spacing: 0.15em; cursor: pointer; font-size: 12px;">
                Reset Filters
              </button>
            </div>
          </div>
        `;
          return;
        }

        const cardsHtml = items.map(p => {
          const pdpUrl = (function (p) {
            const src = p.url || p.product_url || p.shopify_url || "";
            if (src.includes("/products/")) return "/products/" + src.split("/products/").pop();
            let handle = p.shopify_handle || p.handle || (p.id ? p.id.toString().split("/").pop() : "");
            return handle ? `/products/${handle}` : "#";
          })(p);
          const rawImageUrl = p.primary_image_url
            || (p.images && p.images.length && (p.images[0].uri || p.images[0]))
            || p.gcs_image_url || p.shopify_image_url || p.image_url || p.image || p.visualizer_image_url || "";
          const imageUrl = getOptimizedImageUrl(rawImageUrl);
          const imagesArray = [
            { uri: p.gcs_image_url }, { uri: p.image_url }, { uri: p.visualizer_image_url }, { uri: p.shopify_image_url }, { uri: p.image }, { uri: rawImageUrl }
          ].filter(img => img.uri).concat(p.images && p.images.length ? p.images : []);
          const isExplicitSize = !!p.has_explicit_size_intent;
          const minPrice = p.min_price || p.price;
          const maxPrice = p.max_price || p.price;

          let priceHtml = '';
          if (isExplicitSize || !minPrice || minPrice === maxPrice) {
            priceHtml = `<span class="price" style="font-weight:900; color:#000; font-size:15px; display:block; margin-top:2px; letter-spacing: 0.05em;">$${Number(p.price || minPrice).toLocaleString()}</span>`;
          } else {
            priceHtml = `<span class="price" style="font-weight:900; color:#000; font-size:15px; display:block; margin-top:2px; letter-spacing: 0.05em;">$${Number(minPrice).toLocaleString()} - $${Number(maxPrice).toLocaleString()}</span>`;
          }

          let swatchesHtml = '';
          const variants = p.variants_info || [];
          if (!isExplicitSize && variants.length > 0) {
            // Optimization: On mobile, if there are 3+ sizes, hide the individual swatches
            // and show a single "X Sizes Available" button to preserve vertical space for the rug image.
            const isMobile = window.innerWidth < 750;
            // Show only 3 sizes per card so every card stays one row tall and the
            // grid/image alignment stays consistent; the rest collapse into "+N more".
            const initialLimit = (isMobile && variants.length > 2) ? 0 : 3;
            const hasMore = variants.length > initialLimit;

            swatchesHtml = `
            <div class="size-swatches">
              ${variants.map((v, idx) => {
              const style = idx >= initialLimit ? 'display:none;' : '';
              const className = idx >= initialLimit ? 'swatch-hidden' : '';
              let vUrl = v.url || pdpUrl;
              if (vUrl && vUrl.includes("/products/")) {
                const parts = vUrl.split("/products/");
                vUrl = "/products/" + parts[parts.length - 1];
              }
              if (v.variant_id) {
                try {
                  const urlObj = new URL(vUrl, window.location.origin);
                  urlObj.searchParams.set("variant", v.variant_id);
                  vUrl = urlObj.pathname + urlObj.search;
                } catch (e) {
                  if (!vUrl.includes("variant=")) {
                    vUrl += (vUrl.includes("?") ? "&" : "?") + "variant=" + v.variant_id;
                  }
                }
              }
              return `<a href="${vUrl}" class="${className}" onclick="event.stopPropagation();" style="${style}">${v.size}</a>`;
            }).join('')}
              ${hasMore ? `<span class="swatch-more" onclick="event.preventDefault(); event.stopPropagation(); this.parentElement.querySelectorAll('.swatch-hidden').forEach(el=>el.style.display='inline-block'); this.style.display='none';">${initialLimit === 0 ? `<span style="border-bottom:1px solid #666; padding-bottom:1px;">${variants.length} Sizes Available</span>` : `+${variants.length - initialLimit} more`}</span>` : ''}
            </div>
          `;
          }

          const displaySize = p.selected_size || p.size_bucket || p.size || "";
          const displayShape = (p.shape || "").toString().trim();
          const shapeLabel = displayShape ? displayShape[0].toUpperCase() + displayShape.slice(1) : "";

          const metaLineParts = [];
          if (p.brands) {
            const b = Array.isArray(p.brands) ? p.brands[0] : p.brands;
            if (b) metaLineParts.push(`<span style="color:#000; font-weight:900;">${b}</span>`);
          }
          if (displaySize && isExplicitSize) metaLineParts.push(displaySize);
          if (shapeLabel) metaLineParts.push(shapeLabel);

          const pMat = p.material || p.materials || "";
          const displayMat = Array.isArray(pMat) ? pMat[0] : pMat;
          if (displayMat && displayMat.toLowerCase() !== 'n/a') metaLineParts.push(displayMat);

          const metaLineHtml = metaLineParts.length ? `<div class="card-information vertex-meta-line" style="font-size:10px; color:#aaa; margin:4px 0; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1.2;">${metaLineParts.join(' • ')}</div>` : '';

          const safeTitle = (p.title || "Untitled Rug").replace(/'/g, "\\'");
          const safeHandle = (p.shopify_handle || p.handle || "").replace(/'/g, "\\'");
          // HTML-attribute-safe versions for the proactive recovery pass
          const attrTitle = (p.title || "Untitled Rug").replace(/"/g, "&quot;");
          const attrHandle = (p.shopify_handle || p.handle || "").replace(/"/g, "&quot;");

          return `
          <div class="vertex-grid-item">
            <div class="card-wrapper product-card-wrapper">
              <div class="card card--standard">
                <div class="card__inner">
                  <a href="${pdpUrl}" class="full-unstyled-link" onclick="return vertexNavigate(event, '${pdpUrl}', '${safeHandle}', '${safeTitle}')">
                    <img src="${imageUrl}" alt="${p.title || ''}" loading="lazy" data-current-url="${rawImageUrl}" data-vr-handle="${attrHandle}" data-vr-title="${attrTitle}" style="width:100%;min-height:1px;" onerror="if(window.handleVertexImageError) window.handleVertexImageError(this, '${btoa(JSON.stringify(imagesArray))}', '${safeHandle}', '${safeTitle}')"/>
                  </a>
                </div>
                <div class="card__content" style="padding-top: 8px;">
                  <h3 class="card__heading h5 vertex-card-title" style="margin-bottom:0; font-weight: 900; text-transform: uppercase; letter-spacing: 0.05em; font-size: 12px; line-height: 1.3; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                    <a href="${pdpUrl}" class="full-unstyled-link" style="text-decoration:none; color: #000;" onclick="return vertexNavigate(event, '${pdpUrl}', '${safeHandle}', '${safeTitle}')">${p.title || "Untitled Rug"}</a>
                  </h3>
                  ${metaLineHtml}
                  <div class="card-information vertex-card-info" style="margin-top: 4px;">
                    ${priceHtml}
                    <button class="see-in-room-btn"
                      style="margin-top: 10px; width: 100%; padding: 8px; background: #fff; color: #000; border: 1px solid #ddd; border-radius: 4px; font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.1em; cursor: pointer; transition: all 0.2s;"
                      onmouseover="this.style.background='#f7f7f7'; this.style.color='#000';"
                      onmouseout="this.style.background='#fff'; this.style.color='#000';"
                      data-rug="${p.gcs_image_url || p.visualizer_image_url || p.shopify_image_url || p.image_url || p.image || ''}" 
                      data-product-url="${pdpUrl}" 
                      data-shape="${p.shape || ''}" 
                      data-size="${p.selected_size || p.size_bucket || ''}">
                      See in My Room
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
        }).join("");

        const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE) || 1;

        // Per-page size selector (only meaningful once there are more than the smallest option)
        const pageSizeSel = totalItems > PAGE_SIZE_OPTIONS[0]
          ? `<span class="vps__sizewrap"><label class="vps__sizelabel">Per page</label><select class="vps__size" onchange="setSearchPageSize(this.value)">${PAGE_SIZE_OPTIONS.map(n => `<option value="${n}" ${n === ITEMS_PER_PAGE ? 'selected' : ''}>${n}</option>`).join('')}</select></span>`
          : '';

        // Windowed numbered pages with ellipsis: 1 … (cur-2 … cur+2) … last
        const pageItems = [];
        if (totalPages > 1) {
          const win = 2;
          let last = 0;
          for (let p = 1; p <= totalPages; p++) {
            if (p === 1 || p === totalPages || (p >= currentPage - win && p <= currentPage + win)) {
              if (last && p - last > 1) pageItems.push('…');
              pageItems.push(p);
              last = p;
            }
          }
        }
        const numsHtml = pageItems.map(p =>
          p === '…'
            ? `<span class="vps__ellipsis">…</span>`
            : `<button class="vps__num${p === currentPage ? ' is-active' : ''}" ${p === currentPage ? 'aria-current="page"' : ''} onclick="goToSearchAiPage(${p})">${p}</button>`
        ).join('');

        let pagination = '';
        if (totalPages > 1 || pageSizeSel) {
          pagination = `
          <style>
            .vps{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;margin-top:40px;padding-top:30px;border-top:1px solid #eee;}
            .vps__arrow,.vps__num{cursor:pointer;background:#fff;color:#000;border:1px solid #ddd;font-weight:700;font-size:12px;padding:10px 14px;border-radius:4px;transition:all .15s;}
            .vps__arrow{text-transform:uppercase;letter-spacing:.08em;}
            .vps__num{min-width:42px;}
            .vps__arrow:hover:not([disabled]),.vps__num:hover{background:#f5f5f5;border-color:#bbb;}
            .vps__arrow[disabled]{opacity:.4;cursor:not-allowed;}
            .vps__num.is-active{background:#1a1a1a;color:#fff;border-color:#1a1a1a;}
            .vps__nums{display:flex;gap:6px;flex-wrap:wrap;justify-content:center;}
            .vps__ellipsis{padding:10px 2px;color:#999;}
            .vps__meta{text-align:center;margin-top:14px;font-size:12px;color:#777;display:flex;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;}
            .vps__sizewrap{display:inline-flex;align-items:center;gap:8px;}
            .vps__sizelabel{font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#555;}
            .vps__size{padding:6px 10px;border:1px solid #ddd;border-radius:4px;font-size:12px;font-family:inherit;background:#fff;cursor:pointer;color:#000;}
            @media(max-width:600px){.vps__arrow,.vps__num{padding:9px 11px;font-size:11px;min-width:36px;}}
          </style>
          ${totalPages > 1 ? `<nav class="vps" aria-label="Pagination">
            <button class="vps__arrow" ${currentPage === 1 ? 'disabled' : ''} onclick="changeSearchAiPage(-1)">&larr; Prev</button>
            <div class="vps__nums">${numsHtml}</div>
            <button class="vps__arrow" ${currentPage === totalPages ? 'disabled' : ''} onclick="changeSearchAiPage(1)">Next &rarr;</button>
          </nav>` : ''}
          <div class="vps__meta">${totalPages > 1 ? `<span>Page ${currentPage} of ${totalPages}</span>` : ''}${pageSizeSel}</div>`;
        }

        vertexRoot.innerHTML = `
        <style>
          .vertex-search-root { background-color: #ffffff !important; color: #000 !important; font-family: inherit; width: 100%; min-height: 100vh; padding-bottom: 50px; }
          .vertex-search-layout { display: grid; grid-template-columns: 280px 1fr; gap: 60px; padding: 40px 20px; max-width: 1600px; margin: 0 auto; position: relative; }
          .vertex-sidebar { position: sticky; top: 120px; align-self: start; z-index: 10; }
          .vertex-main-results { border-left: 1px solid #eee; padding-left: 40px; }
          .mobile-filter-bar { display: none; }
          .vertex-results-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; align-items: stretch; }
          
          .vertex-product-img:hover { transform: scale(1.05); }
          .vertex-grid-item { display: flex; flex-direction: column; }

          /* Uniform image tiles so every card aligns like the native collection grid.
             The fixed ratio is on the CONTAINER so the box height is reserved before the
             image loads — this prevents the staggered "one up, one down" layout shift while
             images download. */
          .vertex-grid-item .card__inner {
            position: relative;
            aspect-ratio: 1 / 1;
            background: #f5f5f5;
            border-radius: 6px;
            overflow: hidden;
          }
          .vertex-grid-item .card__inner {
            flex-shrink: 0;
          }
          .vertex-grid-item .card__inner img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 0.3s ease;
          }
          .vertex-grid-item .card__inner:hover img { transform: scale(1.04); }

          /* Equal-height cards: make the whole card a flex column and pin the
             "See in My Room" button to the bottom so every card's button lines up,
             regardless of title length or how many size pills a product has. */
          .vertex-grid-item .card-wrapper { flex: 1 1 auto; display: flex; width: 100%; }
          .vertex-grid-item .card { flex: 1 1 auto; display: flex; flex-direction: column; width: 100%; }
          .vertex-grid-item .card__content { flex: 1 1 auto; display: flex; flex-direction: column; }
          .vertex-grid-item .vertex-card-title { min-height: 2.6em; } /* reserve 2 lines */
          .vertex-grid-item .vertex-card-info { display: flex; flex-direction: column; flex: 1 1 auto; }
          .vertex-grid-item .see-in-room-btn { margin-top: auto !important; }

          @media (max-width: 989px) {
            .vertex-search-layout { grid-template-columns: 1fr; padding: 0 15px; }
            .vertex-sidebar { 
              position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
              z-index: 9999; padding: 30px; overflow-y: auto; background: #ffffff;
              transform: translateX(-100%); transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            }
            .vertex-sidebar.active { transform: translateX(0); }
            .vertex-main-results { border-left: none; padding-left: 0; }
            .mobile-filter-bar { display: flex; justify-content: space-between; align-items: center; padding: 15px 0; margin-bottom: 20px; border-bottom: 1px solid #eee; }
            .vertex-mobile-close { display: block; }
            .vertex-results-grid { grid-template-columns: repeat(2, 1fr); gap: 15px; }
          }
          @media (max-width: 500px) {
             .vertex-results-grid { grid-template-columns: 1fr; gap: 20px; }
          }
          
          .size-swatches {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 8px;
          }
          .size-swatches a {
            position: relative;
            z-index: 10;
            font-size: 10px;
            color: #333;
            border: 1px solid #ddd;
            padding: 5px 10px;
            border-radius: 3px;
            text-transform: uppercase;
            font-weight: 600;
            text-decoration: none;
            background: #fff;
            transition: all 0.2s ease;
            display: inline-block;
          }
          .size-swatches a:hover {
            background: #e6e6e6;
            color: #000;
            border-color: #ccc;
          }
          .swatch-more {
            position: relative;
            z-index: 10;
            font-size: 10px;
            color: #555;
            padding: 4px 0;
            font-weight: 700;
            cursor: pointer;
            text-transform: uppercase;
            margin-left: 4px;
            transition: color 0.2s ease;
            display: inline-block;
          }
          .swatch-more:hover {
            color: #000;
          }
        </style>

        <div class="vertex-search-layout">
          <aside class="vertex-sidebar">
            ${renderFilters(currentFacets)}
          </aside>

          <main class="vertex-main-results">
            <div class="mobile-filter-bar">
               <button onclick="toggleMobileFilters()" style="background: #fff; color: #000; border: 1px solid #ddd; padding: 10px 20px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.1em; cursor: pointer; font-size: 11px;">Refine Results</button>
               <span style="font-size: 12px; font-weight: 700; color: #aaa; text-transform: uppercase; letter-spacing: 0.05em;">${totalItems} Items</span>
            </div>

            ${fallbackBannerHtml}
            
            <div class="vertex-results-grid">
              ${cardsHtml}
            </div>
            ${pagination}
          </main>
        </div>
      `;

      // Bulletproof image recovery: an empty <img src=""> never fires onerror, and some
      // stale URLs fail silently — so verify every card image actually loaded and recover
      // any that are empty or broken (naturalWidth === 0 once complete) from the live store.
      const verifyVertexImages = () => {
        vertexRoot.querySelectorAll('img[data-vr-handle]').forEach((im) => {
          if (im.getAttribute('data-retried-discovery')) return;
          const cur = (im.getAttribute('data-current-url') || '').trim();
          const brokenLoad = im.complete && im.naturalWidth === 0;
          if (!cur || brokenLoad) {
            im.setAttribute('data-retried-discovery', 'true');
            window.vrRecoverShopifyImage(im, im.getAttribute('data-vr-handle'), im.getAttribute('data-vr-title'));
          }
        });
      };
      verifyVertexImages();            // immediate: catches empty-src cards
      setTimeout(verifyVertexImages, 1500); // delayed: catches images that 404 after load attempt
      } catch (err) {
        document.getElementById("vertex-search-root").innerHTML = "<div style='padding:50px; color:red; font-size: 20px;'>Error Rendering: " + err.message + "<br>" + err.stack + "</div>";
        console.error("Vertex render error:", err);
      }
    }

    performAiSearch();
  };

  initSearch();
})();